const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SocialSecurity[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Yes2[2]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[2]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].Yes2[1]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[1]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis1[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis1[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis2[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis2[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis3[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis3[0]",
        }    
    ]

}

export default ssn ;